// extracted by mini-css-extract-plugin
module.exports = {"button-wrapper":"IndexPage_button-wrapper__t2nG6"};